// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3lg4t","actions":"GroupTable_actions__3jTSK","deleteModalFooter":"GroupTable_deleteModalFooter__2lr_2"};